var map = {
	"./cloud/1-infraestruturas.svg": 356,
	"./cloud/2-aplicacoes.svg": 357,
	"./cloud/3-publica.svg": 358,
	"./cloud/4-privada.svg": 359,
	"./cloud/5-suporte.svg": 360,
	"./homepage/1-icon.svg": 361,
	"./homepage/2-icon.svg": 362,
	"./homepage/3-icon.svg": 363,
	"./homepage/4-icon.svg": 364,
	"./homepage/5-icon.svg": 365,
	"./homepage/6-icon.svg": 366,
	"./icon-rato.svg": 192,
	"./jobs/1_curiosidade.svg": 367,
	"./jobs/2_atitude.svg": 368,
	"./jobs/3_transparencia.svg": 369,
	"./jobs/4_equipa.svg": 370,
	"./play.svg": 138,
	"./ux-ui/1-comunicacao.svg": 371,
	"./ux-ui/2-produtos.svg": 372,
	"./ux-ui/3-aumento.svg": 373,
	"./why-nearshorit/1-talento.svg": 374,
	"./why-nearshorit/2-reducao-custos.svg": 375,
	"./why-nearshorit/3-reducao-risco.svg": 376,
	"./why-nearshorit/4_projetos.svg": 377,
	"./why-nearshorit/5_core.svg": 378,
	"./why-nearshorit/6_eficiencia.svg": 379,
	"./why-nearshorit/7_proximidade.svg": 380,
	"./world.svg": 381
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1483;